// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Landing from "@material-ui/icons/FlightLandOutlined";
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Settings from "@material-ui/icons/SettingsApplications";
import PscSettings from "@material-ui/icons/SettingsBackupRestore";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Email from "@material-ui/icons/Email";
import Report from "@material-ui/icons/Report";
import Reconciliation from "@material-ui/icons/RestorePage";
import MakerChecker from "@material-ui/icons/ChangeHistory";
import AirlineRouteIcon from "@material-ui/icons/Flight";
import Audit from "@material-ui/icons/TrackChanges";
import WalletIcon from "@material-ui/icons/Flight";
import Receipt from "@material-ui/icons/Receipt";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";
import Reports from "layouts/recordsLanding/regional-reports-landing.js";

import DashboardPage from "Regional-Views/Dashboard/Dashboard.jsx";
import AirlinesPassengerPage from "Regional-Views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "Regional-Views/AirlinePayment/Index.jsx";
import SettlementPage from "Regional-Views/Settlement/Index.jsx";
import OutstandingSettlementPage from "Regional-Views/OutstandingSettlement/Index.jsx";
import SettingsPage from "Regional-Views/Settings/Index.jsx";
import ExchangeRate from "Regional-Views/ExchangeRate/Index.jsx";
import BillablePassengers from "Regional-Views/BillablePassengers/Index.jsx";
import PSCUtilization from "Regional-Views/PSCUtilization/Index.jsx";
import PscSettingsTable from "Regional-Views/PscSettings/Index.jsx";
import EmailSettings from "Regional-Views/EmailSettings/Index.jsx";
import ReconciliationPage from "Regional-Views/Reconciliation/Index.jsx";
import Audits from "Regional-Views/AuditTrail/Index.jsx";
import DataEntry from "Regional-Views/DataEntry/Index.jsx";
import AirlineRouteSetting from "Regional-Views/AirlineRouteSettings";
import NotFound from "Regional-Views/NotFound/Index.jsx";
import WalletReport from "Regional-Views/WalletReport";
import PDM from "Regional-Views/PDM/Index.jsx";
import BillablePscSettings from "Regional-Views/BillablePscSettings/Index.jsx"
import MakerCheckerPage from "Regional-Views/MakerChecker/Index.jsx";
import StatementOfAccount from "Regional-Views/StatementOfAccount/Index.jsx";
import TransitPassengerPage from "Regional-Views/Transit/Index.jsx";
import ExchangeRateAirlineView from "Regional-Views/ExchangeRateAirline/airlineView.js";
import InvoiceApproval from "Regional-Views/InvoiceApproval/Index";
import HelpCenter from "../Regional-Views/HelpCenter";
import HelpIcon from "@material-ui/icons/HelpOutline"



//This route component is used by vggAdmin and client Super admin.
// Components not shown in either is handled by the setRegionalClientAdminRoutes method in Dashboard component under layouts
const dashboardRoutes =  [
    {
        path: "/main-landing",
        sidebarName: "Main Landing",
        navbarName: "Main Landing",
        icon: Landing,
        component: MainLandingPage,
        subMenu: [],
    },
    // {
    //     path: "/landing",
    //     sidebarName: "Home",
    //     navbarName: "Home",
    //     icon: Dashboard,
    //     component: DashboardPage,
    //     subMenu: [],
    //
    // },
    {
        path: "/app/psc-regional/dashboard",
        sidebarName: "Dashboard",
        // isNotVisible: true,
        navbarName: "Dashboard",
        icon: Dashboard,
        subMenu: [],
        component: DashboardPage
    },
    {
        path: "/app/psc-regional/passenger-data",
        sidebarName: "Passenger Data",
        navbarName: "Airline Passenger Data",
        icon: Passenger,
        subMenu: [],
        component: AirlinesPassengerPage
    },
    {
        path: "/app/psc-regional/airline-payment",
        sidebarName: "Airline Payment",
        navbarName: "Airline Payment Report",
        icon: Flight,
        subMenu: [],
        component: AirlinePaymentPage
    },
    {
        path: "/app/psc-regional/psc-settlement",
        sidebarName: " PSC Settlement",
        navbarName: "PSC Settlement",
        icon: Settlement,
        subMenu: [],
        component: SettlementPage
    },
    {
        path: "/app/psc-regional/outstanding-settlement",
        sidebarName: " Outstanding Settlement",
        navbarName: "Outstanding Settlement",
        icon: Settlement,
        subMenu: [],
        component: OutstandingSettlementPage
    },
    {
        path: "/app/psc-regional/invoice-approval",
        sidebarName: " Payment Approval",
        navbarName: "Payment Approval",
        icon: Receipt,
        subMenu: [],
        component: InvoiceApproval
    },
    {
        path: "/app/psc-regional/exchange-rate",
        sidebarName: "Exchange Rate",
        navbarName: "Exchange Rate",
        icon: AirlineRouteIcon,
        subMenu: [],
        component: ExchangeRateAirlineView,
    },
    {
        path: "/app/psc-regional/settings",
        sidebarName: "Settings",
        navbarName: "Settings",
        subMenu: [
            {
                path: "/app/psc-regional/settings",
                sidebarName: "Re-order Level",
                navbarName: "Re-order Level",
                component: SettingsPage
            },
            {
                path: "/app/psc-regional/pscSettings",
                sidebarName: "PSC Settings",
                navbarName: "PSC Settings",
                icon: PscSettings,
                component: PscSettingsTable
            },
            {
                path: "/app/psc-regional/emailSettings",
                sidebarName: "Email Settings",
                navbarName: "Email Settings",
                icon: Email,
                component: EmailSettings
            },
            {
                path: "/app/psc-regional/airlineRouteSettings",
                sidebarName: "Airline Routes",
                navbarName: "Airline Routes Settings",
                icon: AirlineRouteIcon,
                component: AirlineRouteSetting
            },
            {
                path: "/app/psc-regional/billableSettings",
                sidebarName: "Billable Passenger",
                navbarName: "Billable Passenger Settings",
                icon: AirlineRouteIcon,
                component: BillablePscSettings,

            },
            {
                path: "/app/psc-regional/exchangeRate",
                sidebarName: "Exchange Rate Setup",
                navbarName: "Exchange Rate Setup",
                icon: AirlineRouteIcon,
                component: ExchangeRate,
            },
        ],
        icon: Settings,
        component: SettingsPage
    },
    {
        path: "/app/psc-regional/pscSettings",
        sidebarName: "PSC Settings",
        navbarName: "PSC Settings",
        icon: PscSettings,
        isNotVisible: true,
        component: PscSettingsTable,
        subMenu: [],

    },
    {
        path: "/app/psc-regional/emailSettings",
        sidebarName: "Email Settings",
        navbarName: "Email Settings",
        icon: Email,
        isNotVisible: true,
        component: EmailSettings,
        subMenu: [],

    },
    {
        path: "/app/psc-regional/airlineRouteSettings",
        sidebarName: "Airline Routes",
        navbarName: "Airline Routes Settings",
        icon: AirlineRouteIcon,
        isNotVisible: true,
        component: AirlineRouteSetting,
        subMenu: []
    },
    {
        path: "/app/psc-regional/billableSettings",
        sidebarName: "Billable Passenger",
        navbarName: "Billable Passenger Settings",
        icon: AirlineRouteIcon,
        component: BillablePscSettings,
        isNotVisible: true,
        subMenu: [],
    },
    {
        path: "/app/psc-regional/exchangeRate",
        sidebarName: "Exchange Rate",
        navbarName: "Exchange Rate",
        icon: AirlineRouteIcon,
        component: ExchangeRate,
        isNotVisible: true,
        subMenu: [],
    },
    {
        path: "/app/psc-regional/reconciliation",
        sidebarName: "Reconciliation",
        navbarName: "Reconciliation",
        icon: Reconciliation,
        component: ReconciliationPage,
        subMenu: []
    },
    {
        path: "/app/psc-regional/reports-landing",
        sidebarName: "PSC  Reports",
        navbarName: "Psc  Reports",
        icon: Report,
        component: Reports,
        subMenu: [],

    },
    {
        path: "/app/psc-regional/psc-utilization",
        sidebarName: "PSC Utilization",
        isNotVisible: true,
        navbarName: "PSC Utilization",
        icon: Dashboard,
        component: PSCUtilization,
        subMenu: [],

    },
    {
        path: "/app/psc-regional/billable-passengers",
        sidebarName: "Billable Passengers",
        isNotVisible: true,
        navbarName: "Total Passengers vs Billable Passengers",
        icon: BillablePassengers,
        component: BillablePassengers,
        subMenu: [],

    },
    {
        path: "/app/psc-regional/transit-passenger-report",
        sidebarName: "Transit Passenger",
        isNotVisible: true,
        navbarName: "Transit Passenger",
        icon: Report,
        component: TransitPassengerPage,
        subMenu: [],

    },
    {
        path: "/app/psc-regional/statement-of-account",
        sidebarName: "Account Statement",
        isNotVisible: true,
        navbarName: "Account Statement",
        icon: Reconciliation,
        component: StatementOfAccount,
        subMenu: []
    },
    {
        path: "/app/psc-regional/audits",
        sidebarName: "Audit Trail",
        navbarName: "Audit Trail",
        icon: Audit,
        subMenu: [],
        component: Audits,
    },
    {
        path: "/app/psc-regional/dataEntry",
        sidebarName: "Data Entry",
        navbarName: "Data Entry",
        icon: Reconciliation,
        component: DataEntry,
        subMenu: []
    },
    {
        path: "/app/psc-regional/pdm",
        sidebarName: "PDM",
        navbarName: "PDM",
        icon: Reconciliation,
        component: PDM,
        subMenu: [],

    },
    {
        path: "/app/psc-regional/wallet-report",
        sidebarName: "Airline Wallet Report",
        isNotVisible: true,
        navbarName: "Airline Wallet Report",
        icon: WalletIcon,
        component: WalletReport,
        subMenu: [],

    },
    {
        path: "/app/psc-regional/maker-checker",
        sidebarName: "Maker Checker",
        navbarName: "Maker Checker",
        icon: MakerChecker,
        component: MakerCheckerPage,
        subMenu: []
    },
    {
        path: "/app/psc-regional/help-center",
        sidebarName: "Help Center",
        navbarName: "Help Center",
        icon: HelpIcon,
        component: HelpCenter,
        subMenu: []
      },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default dashboardRoutes;

// function mapStateToProps(state, ownProps) {
//     const { user, setView } = state;
//     return {
//         user,
//         setView
//     };
// }
//
// export default connect(mapStateToProps)(dashboardRoutes);



// WEBPACK FOOTER //
// ./src/routes/regional-admin.jsx